export { PortalSwitcher_Lazy as PortalSwitcher } from './PortalSwitcher.lazy';
export {
    PortalSwitcher_canSwitch,
    PortalSwitcher_initials,
    PortalSwitcher_toOptions,
} from './mapping';
export type { PortalSwitcher_Option, PortalSwitcher_Data } from './types';
